import React from "react";
import { Wrapper } from "./styles";

export default function NoSecret() {
  return (
    <Wrapper>
      <div className="Container">
        <img
          src="assets/no-secret.png"
          alt="Foto para representar login com senha protegida"
        />
        <div>
          <div className="TitleMainHeading">
            <span className="DescriptionSubtext">Não é</span> SEGREDO
          </div>
          <div className="DescriptionMainHeading">
            As senhas são o verdadeiro problema, tanto para as pessoas que as
            utilizam quanto para as que as gerenciam. Com o tempo, criamos
            centenas de senhas, é fácil perdê-las, e elas são facilmente
            comprometidas.
          </div>
        </div>
      </div>
    </Wrapper>
  );
}
